import React, { useState } from "react";
import axios from "axios";
import { Redirect } from "react-router-dom";
import { storage } from "../../utils";
import { useDashboardRole } from "../../context/dashboardRole";

const OwnerSecurity = () => {
  const { role, me, loading, refresh } = useDashboardRole();
  const [setup, setSetup] = useState(null);
  const [otp, setOtp] = useState("");
  const [recovery, setRecovery] = useState(null);
  const [err, setErr] = useState("");

  if (loading) return null;
  if (role !== "owner") return <Redirect to="/dashboard/access-denied" />;

  const start = async () => {
    setErr("");
    try {
      const token = await storage.load("token");
      const res = await axios.post(
        "/owner/mfa/setup",
        {},
        { headers: { "x-auth": token } }
      );
      setSetup(res.data);
      setRecovery(null);
    } catch (_) {
      setErr("شروع ثبت MFA ناموفق بود.");
    }
  };

  const verify = async () => {
    try {
      const token = await storage.load("token");
      const res = await axios.post(
        "/owner/mfa/verify",
        { otp },
        { headers: { "x-auth": token } }
      );
      setRecovery(res.data.recovery_codes || []);
      setSetup(null);
      refresh();
    } catch (_) {
      setErr("کد یک‌بارمصرف نامعتبر است.");
    }
  };

  return (
    <div className="puDashPage" dir="rtl">
      <h2>امنیت حساب مالک (MFA)</h2>
      <p>
        وضعیت فعلی:{" "}
        {me && me.mfa_enabled ? "فعال" : "غیرفعال — تا قبل از تأیید ثبت، اجباری نیست"}
      </p>
      {err ? <div style={{ color: "#c8102e" }}>{err}</div> : null}
      {!me?.mfa_enabled ? (
        <button type="button" className="btn btn-primary" onClick={start}>
          شروع ثبت Authenticator
        </button>
      ) : null}
      {setup ? (
        <div style={{ marginTop: 16 }}>
          <p>اپ Authenticator را اسکن کنید یا secret را وارد کنید:</p>
          {setup.qr_data_url ? (
            <img src={setup.qr_data_url} alt="MFA QR" width={180} height={180} />
          ) : null}
          <p dir="ltr" style={{ fontFamily: "monospace" }}>
            {setup.secret}
          </p>
          <input
            placeholder="کد ۶ رقمی"
            value={otp}
            onChange={(e) => setOtp(e.target.value)}
          />
          <button type="button" className="btn btn-success" onClick={verify}>
            تأیید و فعال‌سازی
          </button>
        </div>
      ) : null}
      {recovery ? (
        <div style={{ marginTop: 16, background: "#fff8e6", padding: 12 }}>
          <strong>کدهای بازیابی (فقط یک‌بار نمایش):</strong>
          <ul dir="ltr">
            {recovery.map((c) => (
              <li key={c}>{c}</li>
            ))}
          </ul>
          <p>این کدها را در جای امن نگه دارید. دوباره نمایش داده نمی‌شوند.</p>
        </div>
      ) : null}
    </div>
  );
};

export { OwnerSecurity };
